import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, mergeProps as _mergeProps, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "ltcs-request-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = {
  key: 0,
  class: "auto-refresh-badge"
}
const _hoisted_4 = { class: "request-body" }
const _hoisted_5 = { class: "request-section" }
const _hoisted_6 = { class: "section-header" }
const _hoisted_7 = { class: "month-selector" }
const _hoisted_8 = { class: "ltcs-params-preview" }
const _hoisted_9 = { class: "preview-title" }
const _hoisted_10 = { class: "preview-chips" }
const _hoisted_11 = {
  key: 0,
  class: "ym-code"
}
const _hoisted_12 = { class: "request-table" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "type-cell" }
const _hoisted_15 = { class: "type-name" }
const _hoisted_16 = { class: "desc-cell" }
const _hoisted_17 = { class: "action-cell" }
const _hoisted_18 = { class: "history-section" }
const _hoisted_19 = { class: "section-header" }
const _hoisted_20 = { class: "params-cell" }
const _hoisted_21 = {
  key: 0,
  class: "params-cell"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "params-cell progress-msg"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "status-cell" }
const _hoisted_26 = { class: "no-data" }
const _hoisted_27 = { class: "worker-section" }
const _hoisted_28 = { class: "section-header" }
const _hoisted_29 = {
  key: 0,
  class: "worker-empty"
}
const _hoisted_30 = {
  key: 1,
  class: "worker-grid"
}
const _hoisted_31 = { class: "worker-card-header" }
const _hoisted_32 = { class: "worker-id" }
const _hoisted_33 = { class: "worker-card-body" }
const _hoisted_34 = {
  key: 0,
  class: "task-fp"
}
const _hoisted_35 = { class: "result-modal result-modal--large" }
const _hoisted_36 = {
  key: 0,
  class: "header-subtitle"
}
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = {
  key: 0,
  class: "error-section"
}
const _hoisted_39 = { class: "section-title" }
const _hoisted_40 = { class: "error-message" }
const _hoisted_41 = {
  key: 1,
  class: "labor-cost-section"
}
const _hoisted_42 = {
  key: 0,
  class: "labor-cost-card"
}
const _hoisted_43 = { class: "labor-cost-title-bar" }
const _hoisted_44 = { class: "labor-cost-table" }
const _hoisted_45 = { class: "amount" }
const _hoisted_46 = { class: "amount" }
const _hoisted_47 = { class: "amount highlight" }
const _hoisted_48 = { class: "amount highlight" }
const _hoisted_49 = { class: "amount" }
const _hoisted_50 = { class: "amount" }
const _hoisted_51 = { class: "amount" }
const _hoisted_52 = { class: "labor-cost-summary" }
const _hoisted_53 = { class: "summary-item" }
const _hoisted_54 = { class: "value" }
const _hoisted_55 = {
  key: 1,
  class: "no-data-message"
}
const _hoisted_56 = {
  key: 2,
  class: "data-table-section"
}
const _hoisted_57 = { class: "query-conditions" }
const _hoisted_58 = { class: "condition-title" }
const _hoisted_59 = { class: "condition-items" }
const _hoisted_60 = { class: "condition-item" }
const _hoisted_61 = { class: "condition-value" }
const _hoisted_62 = { class: "condition-item" }
const _hoisted_63 = { class: "condition-value" }
const _hoisted_64 = {
  key: 0,
  class: "condition-item"
}
const _hoisted_65 = { class: "condition-value highlight" }
const _hoisted_66 = { class: "summary-cards" }
const _hoisted_67 = { class: "summary-card" }
const _hoisted_68 = { class: "card-icon" }
const _hoisted_69 = { class: "card-content" }
const _hoisted_70 = { class: "card-value" }
const _hoisted_71 = { class: "card-label" }
const _hoisted_72 = {
  key: 0,
  class: "summary-card"
}
const _hoisted_73 = { class: "card-icon" }
const _hoisted_74 = { class: "card-content" }
const _hoisted_75 = { class: "card-value" }
const _hoisted_76 = {
  key: 1,
  class: "summary-card"
}
const _hoisted_77 = { class: "card-icon" }
const _hoisted_78 = { class: "card-content" }
const _hoisted_79 = { class: "card-value" }
const _hoisted_80 = {
  key: 2,
  class: "summary-card"
}
const _hoisted_81 = { class: "card-icon" }
const _hoisted_82 = { class: "card-content" }
const _hoisted_83 = { class: "card-value" }
const _hoisted_84 = {
  key: 3,
  class: "summary-card"
}
const _hoisted_85 = { class: "card-icon" }
const _hoisted_86 = { class: "card-content" }
const _hoisted_87 = { class: "card-value" }
const _hoisted_88 = {
  key: 4,
  class: "summary-card"
}
const _hoisted_89 = { class: "card-icon" }
const _hoisted_90 = { class: "card-content" }
const _hoisted_91 = { class: "card-value" }
const _hoisted_92 = {
  key: 5,
  class: "summary-card summary-card--portal-raw"
}
const _hoisted_93 = { class: "card-icon" }
const _hoisted_94 = { class: "card-content" }
const _hoisted_95 = { class: "card-value" }
const _hoisted_96 = { class: "card-icon" }
const _hoisted_97 = { class: "card-content" }
const _hoisted_98 = { class: "card-value duplicate-link" }
const _hoisted_99 = { class: "card-label" }
const _hoisted_100 = { class: "search-area" }
const _hoisted_101 = { class: "total-count" }
const _hoisted_102 = { class: "no-data" }
const _hoisted_103 = { class: "loading-indicator" }
const _hoisted_104 = { class: "pagination-area" }
const _hoisted_105 = { class: "modal-footer" }

import { ref, computed, onMounted, onUnmounted, inject, watch } from 'vue';
import api from '@/services/api';
import { useMemberYearMonthOptional } from '@/composables/useMemberYearMonth';
import LtcsDuplicateDialog from '@/components/member/request/LtcsDuplicateDialog.vue';
import LtcsClaimDetailPreferNotice from '@/components/member/request/LtcsClaimDetailPreferNotice.vue';
import LtcsRequestConfirmDialog from '@/components/member/request/LtcsRequestConfirmDialog.vue';
import type { LtcsDuplicateGroup } from '@/components/member/request/LtcsDuplicateDialog.vue';
import { getLtcsDuplicatesEndpoint, LTCS_TYPE_IDX_KEY } from '@/constants/ltcsMacro';
import { getLtcsResultHeaders } from '@/constants/ltcsResultHeaders';
import { formatUserFacingError } from '@/utils/formatUserFacingError';
import { CERT_EXPIRED_CRAWL_MESSAGE, hasNewCertExpiredFailure } from '@/utils/certExpiredCrawl';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsRequestPage',
  setup(__props) {

const store = useStore();
const isAdminVerbose = computed(() => (store.getters.roleLevel || 0) >= 60);
const formatRequestError = (message: string) =>
  formatUserFacingError(message, {
    verbose: isAdminVerbose.value,
    fallback: '롱텀케어 접속에 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  });

// 레이아웃에서 제공하는 데이터
const memberData = inject<any>('memberData');
const selectedBizGubun = inject<any>('selectedBizGubun');

const memberCode = computed(() => memberData?.value?.m_code || '');
const bizGubun = computed(() => selectedBizGubun?.value || '');
const facilityName = computed(
  () => memberData?.value?.m_name || memberData?.value?.m_facility_name || ''
);

const confirmDialog = ref({
  show: false,
  type: '',
  typeName: '',
  yearMonth: '',
  bizGubun: '',
  needsYearMonth: true,
});

const { yearMonth: sharedYearMonth, setYearMonth } = useMemberYearMonthOptional(memberCode);
const selectedYearMonth = ref('');
const historyLoading = ref(false);
const historyItems = ref<any[]>([]);
const loadingMap = ref<Record<string, boolean>>({});
const workers = ref<any[]>([]);
const workersLoading = ref(false);
let pollingInterval: ReturnType<typeof setInterval> | null = null;
let workerPollingInterval: ReturnType<typeof setInterval> | null = null;

const snackbar = ref({
  show: false,
  message: '',
  color: 'success'
});

// 결과 보기 모달
const resultModal = ref({
  show: false,
  status: '' as 'completed' | 'failed' | '',
  type: '',
  requestedAt: '',
  completedAt: '',
  result: null as any,
  errorMessage: '',
  yearMonth: '',
  bizGubun: '' // ★ 요청 시 사업구분 저장
});

// 일정계획 데이터 테이블 관련
const scheduleLoading = ref(false);
const scheduleSearch = ref('');
const scheduleData = ref({
  items: [] as any[],
  total: 0,
    summary: {
      totalCount: 0,
      caregiverCount: 0,
      gradeCount: 0,
      totalFee: 0,
      recipientCount: 0,
      dateCount: 0,
      duplicateCount: 0,
      duplicateGroupCount: 0,
      portalRawCount: 0,
      paidCount: 0,
      requestedCount: 0,
      statusPairCount: 0,
    }
});

const duplicateDialogShow = ref(false);
const duplicateLoading = ref(false);
const duplicateGroups = ref<LtcsDuplicateGroup[]>([]);
const duplicateCount = computed(() => Number(scheduleData.value.summary.duplicateCount) || 0);
const duplicateGroupCount = computed(() => Number(scheduleData.value.summary.duplicateGroupCount) || 0);
const duplicateIdxKey = computed(() => {
  const type = normalizeLtcsType(resultModal.value.type);
  return LTCS_TYPE_IDX_KEY[type] || 'idx';
});

const currentPage = ref(1);
const itemsPerPage = ref(50);
const sortBy = ref([{ key: 'clsp_date', order: 'asc' as const }]);

const totalPages = computed(() => Math.ceil(scheduleData.value.total / itemsPerPage.value));

// 현재 타입에 따른 헤더 (ltcsResultHeaders 단일 소스)
const scheduleHeaders = computed(() =>
  getLtcsResultHeaders(normalizeLtcsType(resultModal.value.type))
);

const showCaregiverCount = computed(() => {
  const types = ['caion_ltcs_emp_info', 'caion_ltcs_schedule_plan', 'caion_ltcs_claim', 'caion_ltcs_claim_detail'];
  return types.includes(resultModal.value.type);
});

const showRecipientCount = computed(() => {
  const types = ['caion_ltcs_recipient_info', 'caion_ltcs_schedule_plan', 'caion_ltcs_claim', 'caion_ltcs_claim_detail'];
  return types.includes(resultModal.value.type);
});

const showDateCount = computed(() => {
  const types = ['caion_ltcs_schedule_plan', 'caion_ltcs_claim'];
  return types.includes(resultModal.value.type);
});

/** DB에 남아 있을 수 있는 구 cmq_type → 현재 타입 (조회·표시용) */
const normalizeLtcsType = (type: string) => {
  if (type === 'caion_ltcs_caregiver_plan') return 'caion_ltcs_schedule_plan';
  if (type === 'caion_ltcs_caregiver_info') return 'caion_ltcs_emp_info';
  return type;
};

const TYPE_LABELS: Record<string, { name: string; color: string; icon: string; description: string; needsYearMonth: boolean }> = {
  caion_ltcs_recipient_info: {
    name: '수급자 정보',
    description: '롱텀케어에서 수급자 정보를 가져옵니다.',
    icon: 'mdi-account-heart',
    color: 'secondary',
    needsYearMonth: false
  },
  caion_ltcs_emp_info: {
    name: '요양보호사 정보',
    description: '롱텀케어에서 요양보호사 정보를 가져옵니다.',
    icon: 'mdi-badge-account',
    color: 'success',
    needsYearMonth: false
  },
  caion_ltcs_schedule_plan: {
    name: '요양보호사 일정계획',
    description: '롱텀케어에서 요양보호사 일정계획을 가져옵니다.',
    icon: 'mdi-calendar-clock',
    color: 'info',
    needsYearMonth: true
  },
  caion_ltcs_rfid: {
    name: 'RFID',
    description: '롱텀케어에서 RFID 전송내용을 가져옵니다.',
    icon: 'mdi-nfc-variant',
    color: 'info',
    needsYearMonth: true
  },
  caion_ltcs_claim: {
    name: '청구내역',
    description: '롱텀케어에서 청구내역을 가져옵니다.',
    icon: 'mdi-file-document-outline',
    color: 'primary',
    needsYearMonth: true
  },
  caion_ltcs_claim_detail: {
    name: '청구내역상세',
    description: '롱텀케어에서 청구내역 상세를 가져옵니다.',
    icon: 'mdi-file-document-multiple',
    color: 'secondary',
    needsYearMonth: true
  },
  caion_ltcs_labor_cost: {
    name: '인건비지출내역',
    description: '롱텀케어에서 종사자인건비 지출내역을 가져옵니다.',
    icon: 'mdi-cash-multiple',
    color: 'success',
    needsYearMonth: true
  }
};

const requestTypes = Object.entries(TYPE_LABELS).map(([type, meta]) => ({
  type,
  ...meta
}));

const historyHeaders = [
  { title: '요청 유형', key: 'cmq_type', sortable: false },
  { title: '조회 조건', key: 'cmq_params', sortable: false },
  { title: '상태', key: 'cmq_status', sortable: false },
  { title: '진행', key: 'cmq_progress', sortable: false },
  { title: '워커', key: 'cmq_worker_id', sortable: false },
  { title: '요청일시', key: 'cmq_requested_at', sortable: true },
  { title: '완료일시', key: 'cmq_completed_at', sortable: true },
  { title: '', key: 'actions', sortable: false, width: 60 }
];

// 대기/처리중인 요청이 있는지 확인
const hasActiveRequest = computed(() => {
  return historyItems.value.some(
    item => item.cmq_status === 'pending' || item.cmq_status === 'processing'
  );
});

const yearMonthOptions = computed(() => {
  const options = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
    const title = `${d.getFullYear()}년 ${d.getMonth() + 1}월`;
    options.push({ title, value });
  }
  return options;
});

const getTypeLabel = (type: string) => {
  return TYPE_LABELS[normalizeLtcsType(type)]?.name || type;
};

const getTypeColor = (type: string) => {
  return TYPE_LABELS[normalizeLtcsType(type)]?.color || 'grey';
};

const needsYearMonth = (type: string) => TYPE_LABELS[normalizeLtcsType(type)]?.needsYearMonth ?? true;

const getLatestProgressMessage = (item: any) => {
  const progress = item.cmq_progress;
  if (!progress) return '';
  try {
    const list = Array.isArray(progress) ? progress : (typeof progress === 'string' ? JSON.parse(progress) : []);
    const last = list[list.length - 1];
    return last?.message || last?.status || '';
  } catch {
    return '';
  }
};

const getWorkerStatusColor = (w: any) => {
  if (w.online_status === 'offline') return 'grey';
  if (w.status_label === '처리중') return 'info';
  if (w.status_label === '폴링 대기') return 'success';
  return 'warning';
};

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'pending': return '대기중';
    case 'processing': return '처리중';
    case 'completed': return '완료';
    case 'failed': return '실패';
    case 'cancelled': return '취소됨';
    default: return status;
  }
};

const getStatusColor = (status: string) => {
  switch (status) {
    case 'pending': return 'warning';
    case 'processing': return 'info';
    case 'completed': return 'success';
    case 'failed': return 'error';
    case 'cancelled': return 'grey';
    default: return 'grey';
  }
};

const formatYearMonthDisplay = (ym: string) => {
  if (!ym || ym.length !== 6) return ym || '미선택';
  return `${ym.substring(0, 4)}년 ${parseInt(ym.substring(4, 6), 10)}월`;
};

const getParamsLabel = (params: any) => {
  if (!params) return '-';
  try {
    const p = typeof params === 'string' ? JSON.parse(params) : params;
    const ym = String(p.yearMonth || '');
    const biz = p.bizGubun || '';
    if (!ym && !biz) return '연월 없음';
    if (ym.length === 6) {
      const label = `${formatYearMonthDisplay(ym)} (${ym})`;
      return biz ? `${label} / ${biz}` : label;
    }
    return biz ? `${ym} / ${biz}` : ym;
  } catch {
    return '-';
  }
};

const formatDateTime = (date: string) => {
  if (!date) return '-';
  return new Date(date).toLocaleString('ko-KR');
};

const formatNumber = (num: number | undefined | null) => {
  if (num === undefined || num === null) return '0';
  return num.toLocaleString('ko-KR');
};

const showMessage = (message: string, color = 'success') => {
  snackbar.value = { show: true, message, color };
};

const submitRequest = async (type: string) => {
  if (needsYearMonth(type)) {
    if (!selectedYearMonth.value) {
      showMessage('조회 연월을 선택해주세요.', 'error');
      return;
    }
    if (!bizGubun.value) {
      showMessage('사업구분이 선택되지 않았습니다.', 'error');
      return;
    }
  }
  if (!memberCode.value) {
    showMessage(
      isAdminVerbose.value
        ? '기관 정보(m_code)를 불러올 수 없습니다.'
        : '기관 정보를 불러올 수 없습니다.',
      'error'
    );
    return;
  }

  confirmDialog.value = {
    show: true,
    type,
    typeName: getTypeLabel(type),
    yearMonth: needsYearMonth(type) ? selectedYearMonth.value : '',
    bizGubun: needsYearMonth(type) ? bizGubun.value : '',
    needsYearMonth: needsYearMonth(type),
  };
};

const confirmSubmitRequest = async () => {
  const type = confirmDialog.value.type;
  if (!type) return;

  loadingMap.value[type] = true;
  try {
    const params: Record<string, string> = { m_code: memberCode.value };
    if (needsYearMonth(type)) {
      params.yearMonth = selectedYearMonth.value;
      params.bizGubun = bizGubun.value;
    }

    await api.post('/macro/request', {
      m_code: memberCode.value,
      cmq_type: type,
      params
    });
    confirmDialog.value.show = false;
    const ymHint = needsYearMonth(type)
      ? ` (${formatYearMonthDisplay(selectedYearMonth.value)} · ${selectedYearMonth.value})`
      : '';
    showMessage(`${getTypeLabel(type)} 요청이 등록되었습니다.${ymHint}`);
    loadHistory();
    startPolling();
  } catch (error: any) {
    const msg = formatRequestError(
      error.response?.data?.message || error.message || '요청 등록에 실패했습니다.'
    );
    showMessage(msg, 'error');
  } finally {
    loadingMap.value[type] = false;
  }
};

const cancelRequest = async (item: any) => {
  try {
    await api.post(`/macro/${item.cmq_idx}/cancel`);
    showMessage('요청이 취소되었습니다.');
    loadHistory();
  } catch (error: any) {
    const msg = error.response?.data?.message || '요청 취소에 실패했습니다.';
    showMessage(msg, 'error');
  }
};

// 결과 보기 모달 열기
const showResultModal = async (item: any) => {
  // params에서 yearMonth, bizGubun 추출
  let yearMonth = '';
  let reqBizGubun = '';
  try {
    const params = typeof item.cmq_params === 'string' 
      ? JSON.parse(item.cmq_params) 
      : item.cmq_params;
    yearMonth = params?.yearMonth || '';
    reqBizGubun = params?.bizGubun || '';
  } catch {
    yearMonth = '';
    reqBizGubun = '';
  }

  const normalizedType = normalizeLtcsType(item.cmq_type);

  resultModal.value = {
    show: true,
    status: item.cmq_status,
    type: normalizedType,
    requestedAt: item.cmq_requested_at,
    completedAt: item.cmq_completed_at,
    result: item.cmq_result,
    errorMessage: formatRequestError(item.cmq_error_message || ''),
    yearMonth,
    bizGubun: reqBizGubun // ★ 요청 시 사업구분
  };

  // 성공한 요청인 경우 데이터 로드 (8개 타입 모두 지원)
  const supportedTypes = Object.keys(TYPE_LABELS);
  if (item.cmq_status === 'completed' && supportedTypes.includes(normalizedType)) {
    currentPage.value = 1;
    scheduleSearch.value = '';
    const { defaultSortKey } = getEndpointConfig(normalizedType);
    sortBy.value = [{ key: defaultSortKey, order: 'asc' as const }];
    await loadScheduleData();
  }
};

// 결과 모달 닫기
const closeResultModal = () => {
  resultModal.value.show = false;
  duplicateDialogShow.value = false;
  duplicateGroups.value = [];
  scheduleData.value = {
    items: [],
    total: 0,
    summary: {
      totalCount: 0,
      caregiverCount: 0,
      gradeCount: 0,
      totalFee: 0,
      recipientCount: 0,
      dateCount: 0,
      duplicateCount: 0,
      duplicateGroupCount: 0,
      portalRawCount: 0,
      paidCount: 0,
      requestedCount: 0,
      statusPairCount: 0,
    }
  };
  scheduleSearch.value = '';
  currentPage.value = 1;
};

// 타입별 API 엔드포인트 및 기본 정렬키 매핑
const getEndpointConfig = (type: string) => {
  const normalized = normalizeLtcsType(type);
  const config: Record<string, { endpoint: string; defaultSortKey: string; needsYearMonth: boolean }> = {
    caion_ltcs_recipient_info: { endpoint: '/ltcs/recipient-info', defaultSortKey: 'clsr_recipient_name', needsYearMonth: false },
    caion_ltcs_emp_info: { endpoint: '/ltcs/caregiver-info', defaultSortKey: 'clci_name', needsYearMonth: false },
    caion_ltcs_schedule_plan: { endpoint: '/ltcs/caregiver-plan', defaultSortKey: 'clsp_date', needsYearMonth: true },
    caion_ltcs_rfid: { endpoint: '/ltcs/rfid', defaultSortKey: 'clrf_start_dt', needsYearMonth: true },
    caion_ltcs_claim: { endpoint: '/ltcs/claim', defaultSortKey: 'clc_date', needsYearMonth: true },
    caion_ltcs_claim_detail: { endpoint: '/ltcs/claim-detail', defaultSortKey: 'clcd_date', needsYearMonth: true },
    caion_ltcs_labor_cost: { endpoint: '/ltcs/labor-cost', defaultSortKey: 'yearMonth', needsYearMonth: true }
  };
  return config[normalized] || { endpoint: '/ltcs/recipient-info', defaultSortKey: 'clsr_recipient_name', needsYearMonth: false };
};

const loadScheduleData = async () => {
  if (!memberCode.value) return;

  const { endpoint, defaultSortKey, needsYearMonth: typeNeedsYm } = getEndpointConfig(resultModal.value.type);
  // ★ 요청 시 저장된 bizGubun 사용 (현재 화면의 bizGubun 대신)
  const modalBizGubun = resultModal.value.bizGubun || bizGubun.value;

  if (typeNeedsYm && (!modalBizGubun || !resultModal.value.yearMonth)) return;

  scheduleLoading.value = true;
  try {
    if (resultModal.value.type === 'caion_ltcs_labor_cost') {
      try {
        const res = await api.get(`${endpoint}/${memberCode.value}/${resultModal.value.yearMonth}`, {
          params: { bizGubun: modalBizGubun }
        });

        if (res.data.data) {
          scheduleData.value.items = [res.data.data];
          scheduleData.value.total = 1;
          scheduleData.value.summary = {
            totalCount: 1,
            caregiverCount: 0,
            gradeCount: 0,
            totalFee: (res.data.data.totalCost || 0) + (res.data.data.totalAdd || 0),
            recipientCount: 0,
            dateCount: 0,
            duplicateCount: 0,
            duplicateGroupCount: 0,
          };
          await loadLaborCostDuplicateStats(modalBizGubun);
        } else {
          scheduleData.value.items = [];
          scheduleData.value.total = 0;
          scheduleData.value.summary = {
            totalCount: 0,
            caregiverCount: 0,
            gradeCount: 0,
            totalFee: 0,
            recipientCount: 0,
            dateCount: 0,
            duplicateCount: 0,
            duplicateGroupCount: 0,
          };
        }
      } catch (error) {
        console.error('인건비지출내역 조회 실패:', error);
        scheduleData.value.items = [];
        scheduleData.value.total = 0;
      } finally {
        scheduleLoading.value = false;
      }
      return;
    }

    const sortKey = sortBy.value[0]?.key || defaultSortKey;
    const sortOrder = sortBy.value[0]?.order || 'asc';

    const queryParams: Record<string, any> = {
      mCode: memberCode.value,
      search: scheduleSearch.value,
      sortBy: sortKey,
      sortOrder,
      limit: itemsPerPage.value,
      offset: (currentPage.value - 1) * itemsPerPage.value
    };
    if (modalBizGubun) queryParams.bizGubun = modalBizGubun;
    if (resultModal.value.yearMonth) queryParams.yearMonth = resultModal.value.yearMonth;

    const res = await api.get(endpoint, { params: queryParams });

    scheduleData.value.items = res.data.data || [];
    scheduleData.value.total = res.data.total || 0;

    if (!scheduleSearch.value) {
      const summaryRes = await api.get(`${endpoint}/summary`, {
        params: {
          mCode: memberCode.value,
          ...(modalBizGubun ? { bizGubun: modalBizGubun } : {}),
          ...(resultModal.value.yearMonth ? { yearMonth: resultModal.value.yearMonth } : {})
        }
      });
      scheduleData.value.summary = summaryRes.data.data || {};
    }
  } catch (error) {
    console.error('데이터 조회 실패:', error);
    showMessage('데이터 조회에 실패했습니다.', 'error');
  } finally {
    scheduleLoading.value = false;
  }
};

const loadLaborCostDuplicateStats = async (modalBizGubun: string) => {
  const endpoint = getLtcsDuplicatesEndpoint('caion_ltcs_labor_cost');
  if (!endpoint || !memberCode.value) return;
  try {
    const res = await api.get(endpoint, {
      params: {
        mCode: memberCode.value,
        bizGubun: modalBizGubun,
        yearMonth: resultModal.value.yearMonth,
      },
    });
    const data = res.data?.data || {};
    scheduleData.value.summary.duplicateCount = data.duplicateCount || 0;
    scheduleData.value.summary.duplicateGroupCount = data.duplicateGroupCount || 0;
  } catch (error) {
    console.error('인건비 중복 통계 조회 실패:', error);
  }
};

const loadDuplicateGroups = async () => {
  const endpoint = getLtcsDuplicatesEndpoint(resultModal.value.type);
  if (!endpoint || !memberCode.value) return;

  const modalBizGubun = resultModal.value.bizGubun || bizGubun.value;
  duplicateLoading.value = true;
  try {
    const res = await api.get(endpoint, {
      params: {
        mCode: memberCode.value,
        ...(modalBizGubun ? { bizGubun: modalBizGubun } : {}),
        ...(resultModal.value.yearMonth ? { yearMonth: resultModal.value.yearMonth } : {}),
        groupLimit: 50,
      },
    });
    const data = res.data?.data || {};
    duplicateGroups.value = data.groups || [];
    if (typeof data.duplicateCount === 'number') {
      scheduleData.value.summary.duplicateCount = data.duplicateCount;
    }
    if (typeof data.duplicateGroupCount === 'number') {
      scheduleData.value.summary.duplicateGroupCount = data.duplicateGroupCount;
    }
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '중복 데이터 조회에 실패했습니다.';
    showMessage(msg, 'error');
    console.error('중복 데이터 조회 실패:', error);
  } finally {
    duplicateLoading.value = false;
  }
};

const openDuplicateDialog = async () => {
  if (duplicateCount.value <= 0) return;
  duplicateDialogShow.value = true;
  duplicateGroups.value = [];
  await loadDuplicateGroups();
};

// 검색 실행
const searchScheduleData = () => {
  currentPage.value = 1;
  loadScheduleData();
};

// 검색어 초기화
const clearSearch = () => {
  scheduleSearch.value = '';
  currentPage.value = 1;
  loadScheduleData();
};

// 정렬 변경
const onSortChange = (newSort: any) => {
  sortBy.value = newSort;
  loadScheduleData();
};

// 페이지 변경
const onPageChange = () => {
  loadScheduleData();
};

// 페이지당 표시 건수 변경
const onItemsPerPageChange = () => {
  currentPage.value = 1;
  loadScheduleData();
};

// 연월 포맷팅 (YYYYMM → YYYY년 MM월)
const formatYearMonth = (ym: string) => {
  if (!ym || ym.length !== 6) return ym || '';
  const year = ym.substring(0, 4);
  const month = ym.substring(4, 6);
  return `${year}년 ${parseInt(month)}월`;
};

// 날짜 포맷팅 (월/일)
const formatDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getMonth() + 1}/${d.getDate()}`;
};

// 날짜 포맷팅 (연-월-일)
const formatDateFull = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 시간 범위 포맷팅
const formatTimeRange = (start: string, end: string) => {
  if (!start || !end) return '-';
  return `${start.substring(0, 5)} ~ ${end.substring(0, 5)}`;
};

// 시간 포맷팅 (단일)
const formatTime = (time: string) => {
  if (!time) return '-';
  return time.substring(0, 5);
};

const formatMoney = (val: number | string | null | undefined) => {
  if (val === null || val === undefined || val === '') return '-';
  const n = Number(val);
  if (Number.isNaN(n)) return String(val);
  return `${n.toLocaleString()}원`;
};

const formatRate = (val: number | string | null | undefined) => {
  if (val === null || val === undefined || val === '') return '-';
  const n = Number(val);
  if (Number.isNaN(n)) return String(val);
  return `${n}%`;
};

const formatYn = (val: string | null | undefined) => {
  if (!val || val === 'N') return '-';
  if (val === 'Y') return 'Y';
  return val;
};

// 서비스 타입 색상
const getServiceTypeColor = (type: string) => {
  switch (type) {
    case '방문요양': return 'success';
    case '방문목욕': return 'info';
    case '방문간호': return 'error';
    case '주야간보호': return 'warning';
    default: return 'grey';
  }
};

// 청구 상태 색상
const getClaimStatusColor = (status: string) => {
  switch (status) {
    case '지급':
    case '승인': return 'success';
    case '반려': return 'error';
    case '심사중': return 'warning';
    case '청구의뢰':
    case '청구완료': return 'info';
    default: return 'grey';
  }
};

const loadWorkers = async () => {
  workersLoading.value = true;
  try {
    const res = await api.get('/macro/workers');
    workers.value = res.data.data || [];
  } catch (error) {
    console.error('워커 목록 조회 실패:', error);
  } finally {
    workersLoading.value = false;
  }
};

const loadHistory = async () => {
  if (!memberCode.value) return;

  historyLoading.value = true;
  try {
    const res = await api.get(`/macro/member/${memberCode.value}`, {
      params: { limit: 50 }
    });
    const next = res.data.data || [];
    if (hasNewCertExpiredFailure(historyItems.value, next)) {
      showMessage(CERT_EXPIRED_CRAWL_MESSAGE, 'error');
    }
    historyItems.value = next;
  } catch (error) {
    console.error('요청 내역 조회 실패:', error);
  } finally {
    historyLoading.value = false;
  }
};

// 자동 갱신 폴링
const startPolling = () => {
  if (pollingInterval) return; // 이미 실행 중이면 무시
  
  pollingInterval = setInterval(() => {
    if (hasActiveRequest.value) {
      loadHistory();
    } else {
      stopPolling(); // 활성 요청이 없으면 폴링 중지
    }
  }, 3000); // 3초마다 갱신
};

const stopPolling = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval);
    pollingInterval = null;
  }
};

// 활성 요청 상태 감시
watch(hasActiveRequest, (hasActive) => {
  if (hasActive) {
    startPolling();
  } else {
    stopPolling();
  }
});

// memberCode가 로드되면 히스토리 조회
watch(() => memberCode.value, (newVal) => {
  if (newVal) {
    loadHistory();
  }
}, { immediate: true });

watch(
  sharedYearMonth,
  (ym) => {
    if (ym && selectedYearMonth.value !== ym) {
      selectedYearMonth.value = ym;
    }
  },
  { immediate: true }
);

watch(selectedYearMonth, (ym) => {
  if (!ym || ym.length < 6) return;
  const y = parseInt(ym.slice(0, 4), 10);
  const m = parseInt(ym.slice(4, 6), 10);
  if (y >= 2000 && m >= 1 && m <= 12 && sharedYearMonth.value !== ym) {
    setYearMonth(y, m);
  }
});

onMounted(() => {
  if (!selectedYearMonth.value && yearMonthOptions.value.length > 0) {
    selectedYearMonth.value = yearMonthOptions.value[0].value;
  }
  loadWorkers();
  workerPollingInterval = setInterval(loadWorkers, 15000);
});

onUnmounted(() => {
  stopPolling();
  if (workerPollingInterval) {
    clearInterval(workerPollingInterval);
    workerPollingInterval = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-area" }, [
        _createElementVNode("h2", { class: "page-title" }, "롱텀케어 자료요청"),
        _createElementVNode("p", { class: "page-subtitle" }, "롱텀케어 포털에서 자료를 자동으로 가져옵니다")
      ], -1)),
      (hasActiveRequest.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "14",
              width: "2",
              color: "primary",
              class: "mr-2"
            }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "자동 갱신 중", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("h3", null, "자료 요청", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_select, {
              modelValue: selectedYearMonth.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYearMonth).value = $event)),
              items: yearMonthOptions.value,
              label: "조회 연월",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              style: {"width":"160px"}
            }, null, 8, ["modelValue", "items"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#1e3a5f"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-information-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createTextVNode(" 요청 시 전송되는 조건 ", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              class: _normalizeClass(["preview-chip", { 'is-warn': !selectedYearMonth.value }])
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("em", null, "조회 연월", -1)),
              _createElementVNode("strong", null, _toDisplayString(formatYearMonthDisplay(selectedYearMonth.value)), 1),
              (selectedYearMonth.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(selectedYearMonth.value), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["preview-chip", { 'is-warn': !bizGubun.value }])
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("em", null, "사업구분", -1)),
              _createElementVNode("strong", null, _toDisplayString(bizGubun.value || '미선택'), 1)
            ], 2)
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "preview-hint" }, " 위 연월·사업구분 값으로 서버에 요청이 등록됩니다. 요청 버튼을 누르면 전송 전 한 번 더 확인합니다. ", -1))
        ]),
        _createElementVNode("table", _hoisted_12, [
          _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"50px"} }, "No"),
              _createElementVNode("th", null, "요청 유형"),
              _createElementVNode("th", null, "설명"),
              _createElementVNode("th", { style: {"width":"120px"} }, "요청")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(requestTypes), (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.type
              }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(index + 1), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_v_icon, {
                      color: item.color,
                      size: "20",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.icon), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_16, _toDisplayString(item.description), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    size: "small",
                    class: "btn-register",
                    loading: loadingMap.value[item.type],
                    onClick: ($event: any) => (submitRequest(item.type))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("mdi-send", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[17] || (_cache[17] = _createTextVNode(" 요청 ", -1))
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[20] || (_cache[20] = _createElementVNode("h3", null, "요청 내역", -1)),
          _createVNode(_component_v_btn, {
            variant: "text",
            size: "small",
            onClick: loadHistory,
            loading: historyLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("mdi-refresh", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode(_component_v_data_table, {
          headers: historyHeaders,
          items: historyItems.value,
          loading: historyLoading.value,
          class: "history-table",
          density: "compact",
          "items-per-page": "10"
        }, {
          "item.cmq_type": _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              size: "small",
              color: getTypeColor(item.cmq_type)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getTypeLabel(item.cmq_type)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          "item.cmq_params": _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_20, _toDisplayString(getParamsLabel(item.cmq_params)), 1)
          ]),
          "item.cmq_worker_id": _withCtx(({ item }) => [
            (item.cmq_worker_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.cmq_worker_id), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
          ]),
          "item.cmq_progress": _withCtx(({ item }) => [
            (getLatestProgressMessage(item))
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(getLatestProgressMessage(item)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
          ]),
          "item.cmq_status": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_25, [
              (item.cmq_status === 'processing')
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "14",
                    width: "2",
                    color: "info",
                    class: "mr-1"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_chip, {
                size: "small",
                color: getStatusColor(item.cmq_status)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getStatusLabel(item.cmq_status)), 1)
                ]),
                _: 2
              }, 1032, ["color"]),
              (item.cmq_status === 'failed' && item.cmq_error_message)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 1,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_icon, _mergeProps(props, {
                        size: "16",
                        color: "error",
                        class: "ml-1 error-icon"
                      }), {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode(" mdi-alert-circle ", -1)
                        ]))]),
                        _: 1
                      }, 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(formatRequestError(item.cmq_error_message)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ])
          ]),
          "item.cmq_requested_at": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(formatDateTime(item.cmq_requested_at)), 1)
          ]),
          "item.cmq_completed_at": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(item.cmq_completed_at ? formatDateTime(item.cmq_completed_at) : '-'), 1)
          ]),
          "item.actions": _withCtx(({ item }) => [
            (item.cmq_status === 'completed' || item.cmq_status === 'failed')
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "text",
                  size: "small",
                  color: item.cmq_status === 'completed' ? 'success' : 'error',
                  onClick: ($event: any) => (showResultModal(item)),
                  title: "결과 보기"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("mdi-eye", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color", "onClick"]))
              : _createCommentVNode("", true),
            (item.cmq_status === 'pending' || item.cmq_status === 'processing')
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  icon: "",
                  variant: "text",
                  size: "small",
                  color: "error",
                  onClick: ($event: any) => (cancelRequest(item)),
                  title: "요청 취소"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-close-circle", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          "no-data": _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "grey-lighten-2"
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createTextVNode("mdi-clipboard-text-clock-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[25] || (_cache[25] = _createElementVNode("p", null, "요청 내역이 없습니다", -1))
            ])
          ]),
          _: 1
        }, 8, ["items", "loading"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[27] || (_cache[27] = _createElementVNode("h3", null, "매크로 워커", -1)),
          _createVNode(_component_v_btn, {
            variant: "text",
            size: "small",
            onClick: loadWorkers,
            loading: workersLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("mdi-refresh", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        (workers.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("p", null, "온라인 워커가 없습니다. PC에서 LtcRequest.exe 실행 후 「폴링 시작」을 눌러주세요.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workers.value, (w) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: w.cmw_worker_id,
                  class: _normalizeClass(["worker-card", { offline: w.online_status === 'offline' }])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(w.cmw_worker_id), 1),
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      color: getWorkerStatusColor(w)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(w.status_label), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", null, _toDisplayString(w.cmw_hostname) + " · 슬롯 " + _toDisplayString(w.cmw_instance_slot || 1), 1),
                    (w.cmw_task_fingerprint)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(w.cmw_task_fingerprint), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]))
      ])
    ]),
    _createVNode(LtcsRequestConfirmDialog, {
      modelValue: confirmDialog.value.show,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmDialog.value.show) = $event)),
      "type-name": confirmDialog.value.typeName,
      "year-month": confirmDialog.value.yearMonth,
      "biz-gubun": confirmDialog.value.bizGubun,
      "facility-name": facilityName.value,
      "needs-year-month": confirmDialog.value.needsYearMonth,
      loading: !!loadingMap.value[confirmDialog.value.type],
      onConfirm: confirmSubmitRequest
    }, null, 8, ["modelValue", "type-name", "year-month", "biz-gubun", "facility-name", "needs-year-month", "loading"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"]),
    _createVNode(_component_v_dialog, {
      modelValue: resultModal.value.show,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((resultModal.value.show) = $event)),
      "max-width": "2000",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-header", resultModal.value.status])
          }, [
            _createElementVNode("h3", null, [
              _createVNode(_component_v_icon, {
                size: "20",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(resultModal.value.status === 'completed' ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(resultModal.value.status === 'completed' ? '실행 완료' : '실행 실패') + " ", 1),
              (resultModal.value.status === 'completed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, " - " + _toDisplayString(getTypeLabel(resultModal.value.type)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeResultModal
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ], 2),
          _createElementVNode("div", _hoisted_37, [
            (resultModal.value.status === 'failed' && resultModal.value.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "error",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("mdi-alert", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[31] || (_cache[31] = _createTextVNode(" 실패 원인 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(resultModal.value.errorMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (resultModal.value.status === 'completed' && resultModal.value.type === 'caion_ltcs_labor_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (scheduleData.value.items.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, " (" + _toDisplayString(formatYearMonth(scheduleData.value.items[0]?.yearMonth)) + ") " + _toDisplayString(scheduleData.value.items[0]?.facilityType || '-') + " 심사결정금액 ", 1),
                        _createElementVNode("table", _hoisted_44, [
                          _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", { class: "header-row-1" }, [
                              _createElementVNode("th", { colspan: "2" }, "① 장기요양급여비용(②+③+④)"),
                              _createElementVNode("th", { colspan: "2" }, "② 인건비 비율 반영"),
                              _createElementVNode("th", { colspan: "2" }, "③ 인건비 비율 미반영"),
                              _createElementVNode("th", null, "④ 본인부담금")
                            ]),
                            _createElementVNode("tr", { class: "header-row-2" }, [
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_45, _toDisplayString(formatNumber(scheduleData.value.items[0]?.totalCost)), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(formatNumber(scheduleData.value.items[0]?.totalAdd)), 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(formatNumber(scheduleData.value.items[0]?.laborCost)), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(formatNumber(scheduleData.value.items[0]?.laborAdd)), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(formatNumber(scheduleData.value.items[0]?.nonLaborCost)), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(formatNumber(scheduleData.value.items[0]?.nonLaborAdd)), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(formatNumber(scheduleData.value.items[0]?.selfPayCost)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "인건비 반영 합계", -1)),
                            _createElementVNode("span", _hoisted_54, _toDisplayString(formatNumber((scheduleData.value.items[0]?.laborCost || 0) + (scheduleData.value.items[0]?.laborAdd || 0))) + "원", 1)
                          ]),
                          (duplicateCount.value > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "duplicate-inline-btn",
                                onClick: openDuplicateDialog
                              }, " 중복 " + _toDisplayString(duplicateCount.value.toLocaleString()) + "건 ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "grey-lighten-2"
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode("mdi-file-document-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[35] || (_cache[35] = _createElementVNode("p", null, "해당 조건의 인건비지출내역이 없습니다.", -1))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (resultModal.value.status === 'completed' && resultModal.value.type !== 'caion_ltcs_labor_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                          _createTextVNode("mdi-filter-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[37] || (_cache[37] = _createTextVNode(" 조회 조건 ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "condition-label" }, "사업구분", -1)),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(bizGubun.value || '전체'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "condition-label" }, "연월", -1)),
                        _createElementVNode("span", _hoisted_63, _toDisplayString(formatYearMonth(resultModal.value.yearMonth) || '전체'), 1)
                      ]),
                      (scheduleSearch.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "condition-label" }, "검색어", -1)),
                            _createElementVNode("span", _hoisted_65, _toDisplayString(scheduleSearch.value), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_v_icon, { color: "primary" }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("mdi-calendar-check", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, _toDisplayString(scheduleData.value.summary.totalCount?.toLocaleString() || 0), 1),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(resultModal.value.type === 'caion_ltcs_claim_detail' ? '방문 건수' : '전체 건수'), 1)
                      ])
                    ]),
                    (showCaregiverCount.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_v_icon, { color: "success" }, {
                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("mdi-account-hard-hat", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("span", _hoisted_75, _toDisplayString(scheduleData.value.summary.caregiverCount || 0), 1),
                            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "card-label" }, "종사자", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (showRecipientCount.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_v_icon, { color: "secondary" }, {
                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                _createTextVNode("mdi-account-heart", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("span", _hoisted_79, _toDisplayString(scheduleData.value.summary.recipientCount || 0), 1),
                            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "card-label" }, "수급자", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (showDateCount.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createVNode(_component_v_icon, { color: "info" }, {
                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createTextVNode("mdi-calendar-range", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", _hoisted_83, _toDisplayString(scheduleData.value.summary.dateCount || 0) + "일", 1),
                            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "card-label" }, "날짜수", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (resultModal.value.type === 'caion_ltcs_recipient_info')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_v_icon, { color: "info" }, {
                              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                _createTextVNode("mdi-star", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("span", _hoisted_87, _toDisplayString(scheduleData.value.summary.gradeCount || 0), 1),
                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "card-label" }, "급여종류", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (resultModal.value.type === 'caion_ltcs_claim_detail')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createVNode(_component_v_icon, { color: "warning" }, {
                              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                _createTextVNode("mdi-currency-krw", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("span", _hoisted_91, _toDisplayString((scheduleData.value.summary.totalFee || 0).toLocaleString()) + "원", 1),
                            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "card-label" }, "총 수가", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (resultModal.value.type === 'caion_ltcs_claim_detail' && (scheduleData.value.summary.portalRawCount || 0) > (scheduleData.value.summary.totalCount || 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createVNode(_component_v_icon, { color: "#1565c0" }, {
                              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                _createTextVNode("mdi-file-document-multiple-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("span", _hoisted_95, _toDisplayString((scheduleData.value.summary.portalRawCount || 0).toLocaleString()) + "줄", 1),
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "card-label" }, "포털 원본", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (duplicateCount.value > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 6,
                          type: "button",
                          class: "summary-card summary-card--duplicate",
                          onClick: openDuplicateDialog
                        }, [
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_v_icon, { color: "error" }, {
                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                _createTextVNode("mdi-content-duplicate", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("span", _hoisted_98, _toDisplayString(duplicateCount.value.toLocaleString()) + "건", 1),
                            _createElementVNode("span", _hoisted_99, _toDisplayString(resultModal.value.type === 'caion_ltcs_claim_detail'
                      ? '동일 방문 중복 (클릭)'
                      : '중복 데이터 (클릭)'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (resultModal.value.type === 'caion_ltcs_claim_detail')
                    ? (_openBlock(), _createBlock(LtcsClaimDetailPreferNotice, {
                        key: 0,
                        "portal-raw-count": scheduleData.value.summary.portalRawCount || 0,
                        "display-count": scheduleData.value.summary.totalCount || 0,
                        "status-pair-count": scheduleData.value.summary.statusPairCount || 0
                      }, null, 8, ["portal-raw-count", "display-count", "status-pair-count"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_100, [
                    _createVNode(_component_v_text_field, {
                      modelValue: scheduleSearch.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((scheduleSearch).value = $event)),
                      "prepend-inner-icon": "mdi-magnify",
                      label: "이름 검색 (요양보호사/수급자)",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      style: {"max-width":"300px"},
                      onKeyup: _withKeys(searchScheduleData, ["enter"]),
                      "onClick:clear": clearSearch
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-search",
                      onClick: searchScheduleData
                    }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createTextVNode(" 검색 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("span", _hoisted_101, [
                      _cache[56] || (_cache[56] = _createTextVNode(" 총 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(scheduleData.value.total.toLocaleString()), 1),
                      _cache[57] || (_cache[57] = _createTextVNode("건 ", -1)),
                      (resultModal.value.type === 'caion_ltcs_claim_detail')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (방문)")
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_v_data_table, {
                    headers: scheduleHeaders.value,
                    items: scheduleData.value.items,
                    loading: scheduleLoading.value,
                    "items-per-page": itemsPerPage.value,
                    page: currentPage.value,
                    class: "schedule-table",
                    density: "compact",
                    "sort-by": sortBy.value,
                    "onUpdate:sortBy": onSortChange,
                    "hide-default-footer": ""
                  }, {
                    "item.clsr_wdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateTime(item.clsr_wdate)), 1)
                    ]),
                    "item.clsr_rdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateTime(item.clsr_rdate)), 1)
                    ]),
                    "item.clsr_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: getServiceTypeColor(item.clsr_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clsr_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clci_birth_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clci_birth_date)), 1)
                    ]),
                    "item.clci_work_start_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clci_work_start_date)), 1)
                    ]),
                    "item.clci_work_end_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clci_work_end_date)), 1)
                    ]),
                    "item.clci_wdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateTime(item.clci_wdate)), 1)
                    ]),
                    "item.clsp_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clsp_date)), 1)
                    ]),
                    "item.clsp_start_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatTime(item.clsp_start_time)), 1)
                    ]),
                    "item.clsp_end_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatTime(item.clsp_end_time)), 1)
                    ]),
                    "item.clsp_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: getServiceTypeColor(item.clsp_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clsp_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clsp_is_family": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatYn(item.clsp_is_family)), 1)
                    ]),
                    "item.clsp_caregiver_birth": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clsp_caregiver_birth)), 1)
                    ]),
                    "item.clc_caregiver_birth": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clc_caregiver_birth)), 1)
                    ]),
                    "item.clc_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clc_date)), 1)
                    ]),
                    "item.clc_plan_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatTimeRange(item.clc_plan_start_time, item.clc_plan_end_time)), 1)
                    ]),
                    "item.clc_work_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatTimeRange(item.clc_work_start_time, item.clc_work_end_time)), 1)
                    ]),
                    "item.clc_is_family": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatYn(item.clc_is_family)), 1)
                    ]),
                    "item.clc_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: getServiceTypeColor(item.clc_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clc_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clcd_status": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: getClaimStatusColor(item.clcd_status)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clcd_status || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clcd_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatDateFull(item.clcd_date)), 1)
                    ]),
                    "item.clcd_service_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatTimeRange(item.clcd_service_start_time, item.clcd_service_end_time)), 1)
                    ]),
                    "item.clcd_fee": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatMoney(item.clcd_fee)), 1)
                    ]),
                    "item.clcd_deduction_score": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.clcd_deduction_score ?? '-'), 1)
                    ]),
                    "item.clcd_deduction_rate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(formatRate(item.clcd_deduction_rate)), 1)
                    ]),
                    "no-data": _withCtx(() => [
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "grey-lighten-2"
                        }, {
                          default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                            _createTextVNode("mdi-calendar-blank", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[59] || (_cache[59] = _createElementVNode("p", null, "조회된 일정이 없습니다.", -1))
                      ])
                    ]),
                    loading: _withCtx(() => [
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary"
                        }),
                        _cache[60] || (_cache[60] = _createElementVNode("p", null, "데이터를 불러오는 중...", -1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading", "items-per-page", "page", "sort-by"]),
                  _createElementVNode("div", _hoisted_104, [
                    _createVNode(_component_v_select, {
                      modelValue: itemsPerPage.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((itemsPerPage).value = $event)),
                        onItemsPerPageChange
                      ],
                      items: [20, 50, 100],
                      label: "페이지당 표시",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"120px"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_pagination, {
                      modelValue: currentPage.value,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
                        onPageChange
                      ],
                      length: totalPages.value,
                      "total-visible": 7,
                      density: "compact"
                    }, null, 8, ["modelValue", "length"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-cancel",
              onClick: closeResultModal
            }, {
              default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                _createTextVNode("닫기", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LtcsDuplicateDialog, {
      modelValue: duplicateDialogShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((duplicateDialogShow).value = $event)),
      loading: duplicateLoading.value,
      "duplicate-count": duplicateCount.value,
      "duplicate-group-count": duplicateGroupCount.value,
      groups: duplicateGroups.value,
      "table-headers": scheduleHeaders.value,
      "idx-key": duplicateIdxKey.value,
      "source-type": resultModal.value.type
    }, null, 8, ["modelValue", "loading", "duplicate-count", "duplicate-group-count", "groups", "table-headers", "idx-key", "source-type"])
  ]))
}
}

})